import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import PageHero from '../components/PageHero';
import { tributesApi } from '../services/api';

const GuestbookPage = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    tributesApi.getRecent({ limit: 24 }).then((data) => setItems(data.tributes || [])).catch(() => setItems([]));
  }, []);

  return (
    <Layout>
      <Seo title="سجل الزوار" description="قالوا عن الشهداء: كلمات الرثاء المعتمدة." />
      <PageHero eyebrow="قالوا عن الشهيد" title="سجل الزوار" subtitle="كلمات الزوار بعد مراجعتها، مرتبطة باسم الشهيد." />
      <div className="container-responsive py-12">
        {items.length === 0 && (
          <p className="py-16 text-center text-stone-500">
            لا توجد كلمات منشورة بعد. يمكنك الكتابة من صفحة الشهيد، وتظهر هنا بعد الموافقة.
          </p>
        )}
        <div className="grid gap-6 md:grid-cols-2">
          {items.map((item) => (
            <blockquote key={item.id} className="rounded-3xl border border-gold-500/20 bg-white p-8 dark:bg-stone-900">
              <p className="text-lg leading-relaxed">“{item.message}”</p>
              <footer className="mt-4 text-sm text-gold-700">
                {item.visitor_name} — في ذكرى{' '}
                <Link className="underline" to={`/martyr/${item.martyr_id}`}>{item.martyr_name}</Link>
              </footer>
            </blockquote>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default GuestbookPage;
